import initCalc from './calculator/index'
import './popup/index'

export default () => {
  initCalc();
}